import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import IssuableCard from "@/components/provider/cards/issuables/IssuableCard";
import {DEALicense, IssuableController} from "@/components/provider/cards/issuables/IssuableModels";
import {getRestParamErrorMessage} from "@/utils/serverErrorMessageUtil";
import DEALicenseDetail from "@/components/provider/cards/deaLicense/DEALicenseDetail";

export default Vue.component('dea-license-card', {
  name: 'DEALicenseCard',
  components: {
    IssuableCard,
    DEALicenseDetail,
  },
  methods: {
    issuableController() : IssuableController<DEALicense> {
      return {
        entityName: "DEA License",
        documentUploadPath: "provider/deaLicense/",
        primaryIdField: "deaLicenseId",
        entityType: 4,
        createNewModel(providerId: string) : any {
          return {
            "providerId": providerId,
            "deaLicenseId": "",
            "licenseNumber": "",
            "stateId": "",
            "stateFull": "",
            "stateAbbrev": "",
            "issuedDate": null,
            "expirationDate": null,
            "expirationNoticeDate": null,
            "expirationNoticeSetting": 0,
            "isNew": true,
            "isEditing": true
          }
        },
        getAllForProvider(providerId: string) : Promise<any> {
          return HTTP.get('/api/providers/' + providerId + '/deaLicenses');
        },
        createData(providerId: string, issuable: DEALicense): Promise<any> {
          return HTTP.post('/api/providers/' + providerId + '/deaLicenses', issuable);
        },
        deleteData(providerId: string, id: number): Promise<any> {
          return HTTP.delete('/api/providers/' + providerId + '/deaLicenses/' + id);
        },
        deleteDocument(id: number): Promise<any> {
          return HTTP.delete('/api/facilityDEALicenseDocument/' + id );
        },
        errorsExistOnDynamicFields(issuable: DEALicense): boolean {
          return issuable.stateIdErrorMessage.length + issuable.licenseNumberErrorMessage.length > 0;
        },
        setErrorsOnDynamicFields(issuable: DEALicense, error: any): void {
          issuable.stateIdErrorMessage = getRestParamErrorMessage(error, 'stateId');
          issuable.licenseNumberErrorMessage = getRestParamErrorMessage(error, 'licenseNumber');
        },
        updateData(providerId: string, issuable: DEALicense): Promise<any> {
          return HTTP.put('/api/providers/' + providerId + '/deaLicenses', issuable)
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/deaLicense/DEALicenseCard.ts